export default __webpack_public_path__ + "static/media/minisite.b0b1fa4d.png";